module.exports = __webpack_public_path__ + "static/media/sort.d3ccbee4.svg";